import { createFileRoute, LinkOptions, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/w/$slug/settings")({
  beforeLoad: () => ({
    breadcrumb: {
      title: "Settings",
      link: {
        from: Route.fullPath,
      } satisfies LinkOptions,
    },
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="mx-auto max-w-md w-full">
      <Outlet />
    </div>
  );
}
